import React from 'react';
import { Mail } from 'lucide-react';
import HeroImage from '../components/HeroImage';

function Contact() {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-screen mx-[4.2mm] mt-[4.2mm]">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-[#00ffff]/10 via-transparent to-[#ff0000]/10 animate-gradient rounded-lg z-10"></div>
          <div className="absolute inset-0 rounded-lg overflow-hidden">
            <HeroImage 
              src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=1920&h=1080" 
              alt="Contact hero"
              priority={true}
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50 rounded-lg z-20"></div>
        </div>

        <div className="relative h-full flex items-center z-30">
          <div className="max-w-7xl mx-auto px-4">
            <h1 className="text-5xl font-bold text-center text-white mb-6">Contact Us</h1>
            <p className="text-xl text-white/80 text-center max-w-3xl mx-auto">
              We'd love to hear from you! Whether you have a question, inquiry, or just want to say hello, feel free to reach out. You can contact us at{' '}
              <a 
                href="mailto:jz@thinkatlasai.com" 
                className="text-[#00ffff] hover:text-[#ff0000] transition-colors"
              >
                jz@thinkatlasai.com
              </a>
              , and we'll get back to you as soon as possible. We look forward to connecting with you!
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="white-holographic-card p-8 rounded-xl">
          <div className="flex items-center mb-4">
            <Mail className="h-6 w-6 text-[#00ffff] mr-3" />
            <h3 className="text-xl font-semibold text-gray-800">Email</h3>
          </div>
          <a 
            href="mailto:jz@thinkatlasai.com" 
            className="text-[#00ffff] hover:text-[#ff0000] transition-colors"
          >
            jz@thinkatlasai.com
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;